<script setup lang="ts">
import { withDefaults } from 'vue'
import ProgressBar from './ProgressBar.vue'

interface PropTypes {
  colors?: Array<string>
  progress?: number
  sectionCount?: number
  growBasis?: (index?: number) => number
  total: number 
  bgColor?: string
}

const props = withDefaults(defineProps<PropTypes>(), {
  sectionCount: 1,
  progress: 1,
  colors: () => ['green-400'],
  growBasis: () => 1,
  total: 0,
  bgColor: undefined
})

const defaultColor = 'je-neutral'

const getProgress = (index: number): number => (index <= props.progress ? 100 : 0)
const hasNextSection = (index: number): boolean => (index < props.sectionCount ? true : false)
const getColor = (index: number): string => {
  const arrColor = props.colors[index - 1]
  if (arrColor === undefined) return props.colors[0]
  return arrColor
}
</script>

<template>
  <div class="h-full sectioned-progress-root flex rounded-full overflow-hidden w-100">
    <template v-if="props.total > 0">
      <template v-for="n in props.sectionCount" :key="`${n}-progress-section`">
        <div :class="`grow-${props.growBasis(n)}`">
          <ProgressBar :value="getProgress(n)" :color="getColor(n)" />
        </div>
        <template v-if="hasNextSection(n)">
          <div class="w-1"></div>
        </template>
      </template>
    </template>
    <template v-else>
      <div class="empty-progess grow-1">
        <ProgressBar :value="0" :color="defaultColor" :bg-color="props.bgColor" />
      </div>
    </template>
  </div>
</template>
